import * as React from "react";

import {
    Modal,
    Form,
    FormGroup,
    Label,
    Input,
    ModalFooter,
    Button,
    ModalBody,
    ModalHeader
} from "reactstrap";

import i18n from "../i18n";

export interface ScriptEditProps {
    item: any;
    isOpen: boolean;
    isNew: boolean;
    onSave: (model: any) => void;
    onCancel: (model: any) => void;
    scriptsList: any[];
}
export interface ScriptEditState {
    item: any;
}

export default class ScriptEdit extends React.Component<
    ScriptEditProps,
    ScriptEditState
    > {
    constructor(props: ScriptEditProps) {
        super(props);
        this.state = {
            item: props.item
        };
    }

    componentWillReceiveProps(nextProps: ScriptEditProps) {
        this.setState({
            item: nextProps.item
        });
    }

    render() {
        const { isOpen, onSave, onCancel, isNew } = this.props;
        const model = this.model;
        return (
            <Modal isOpen={isOpen} className="script-edit">
                <ModalHeader>
                    {isNew ? i18n.Scripts.Form.NewTitle : i18n.Scripts.Form.EditTitle}
                </ModalHeader>
                <ModalBody>
                    {model && (
                        <Form>
                            <FormGroup>
                                <Label>{i18n.Scripts.Table.Scenario}</Label>
                                <br />
                                {model.scenarioName}
                            </FormGroup>
                            <FormGroup>
                                <Label>{i18n.Scripts.Table.ScenarioVirtualNode}</Label>
                                <br />
                                {model.virtualNode}
                            </FormGroup>
                            <FormGroup>
                                <Label>{i18n.Scripts.Table.ScenarioCluster}</Label>
                                <br />
                                {model.category}
                            </FormGroup>
                            <FormGroup>
                                <Label>{i18n.Scripts.Table.ScenarioMarket}</Label>
                                <br />
                                {model.market}
                            </FormGroup>
                            <FormGroup>
                                <Label>{i18n.Scripts.Table.ScenarioType}</Label>
                                <br />
                                {model.scenarioType}
                            </FormGroup>
                            <FormGroup>
                                <Label>{i18n.Scripts.Table.NodeId}</Label>
                                <br />
                                {model.id}
                            </FormGroup>
                            <FormGroup>
                                <Label>{i18n.Scripts.Table.ComponentType}</Label>
                                <br />
                                {model.type}
                            </FormGroup>
                            <FormGroup>
                                <Label>
                                    {i18n.Scripts.Table.Text}
                                    <Input
                                        size={50}
                                        value={model.q}
                                        onChange={e => this.updateField("q", e)}
                                    />
                                </Label>
                            </FormGroup>
                            <FormGroup>
                                <Label>
                                    {i18n.Scripts.Table.Speak}
                                    <Input
                                        size={50}
                                        value={model.speak}
                                        onChange={e => this.updateField("speak", e)}
                                    />
                                </Label>
                            </FormGroup>
                            <FormGroup check={true}>
                                <Label check={true}>
                                    <Input
                                        type="checkbox"
                                        checked={model.allowFeedback}
                                        onChange={e => this.updateField("allowFeedback", null, e.target.checked)}
                                    />
                                    {i18n.Scripts.Table.AllowFeedback}
                                </Label>
                            </FormGroup>
                        </Form>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button
                        color="primary"
                        onClick={() => onSave(model)}
                        disabled={!this.isValid}
                    >
                        {i18n.Global.Edit.Confirm}
                    </Button>
                    <Button color="default" onClick={() => onCancel(model)}>
                        {i18n.Global.Edit.Cancel}
                    </Button>
                </ModalFooter>
            </Modal>
        );
    }

    private get model() {
        return this.state.item;
    }

    private get isValid(): boolean {
        return this.model && !!this.model.id;
    }

    private updateField(
        field: string,
        e: React.ChangeEvent<HTMLInputElement> | null,
        value?: any
    ) {
        const temp = {};
        switch (field) {
            case "disabled":
                temp[field] = value
                break;
            default:
                temp[field] = e ? e.target.value : value;
                break;
        }
        this.setState({
            item: {
                ...this.state.item,
                ...temp
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/scripts/script-edit.tsx